import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_clsx__ from "clsx";
import * as __WEBPACK_EXTERNAL_MODULE_tailwind_merge_e05e3e95__ from "tailwind-merge";
function cn(...inputs) {
    return (0, __WEBPACK_EXTERNAL_MODULE_tailwind_merge_e05e3e95__.twMerge)((0, __WEBPACK_EXTERNAL_MODULE_clsx__.clsx)(inputs));
}
function useForwardedRef(ref) {
    const innerRef = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)(null);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        if (!ref) return;
        if ("function" == typeof ref) ref(innerRef.current);
        else ref.current = innerRef.current;
    });
    return innerRef;
}
export { cn, useForwardedRef };

//# sourceMappingURL=utils.mjs.map